import { useState, useCallback } from 'react';

// The payout month picked on Run Payroll (Register and Approve & Credit tabs) is remembered, so a
// page reload or a switch between the two tabs keeps it instead of snapping back to the current month.
const KEY = 'payroll-selected-month';

const read = () => { try { return localStorage.getItem(KEY) || ''; } catch { return ''; } };

export default function usePayrollMonth(months) {
    const [month, setMonthState] = useState(() => {
        const saved = read();
        return months.some((m) => m.value === saved) ? saved : months[0].value;
    });
    const setMonth = useCallback((v) => {
        setMonthState(v);
        try { localStorage.setItem(KEY, v); } catch { /* not remembered */ }
    }, []);
    return [month, setMonth];
}
